import { render, staticRenderFns } from "./NfcAutoAssigner.vue?vue&type=template&id=2d2c9236"
import script from "./NfcAutoAssigner.vue?vue&type=script&lang=js"
export * from "./NfcAutoAssigner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./NfcAutoAssigner.vue?vue&type=custom&index=0&blockType=v-dialog&v-model=scannerDialog"
if (typeof block0 === 'function') block0(component)

export default component.exports